import { createFragmentContainer, graphql } from 'react-relay';
import Library from './Library';

export default createFragmentContainer(
  Library,
  {
    viewer: graphql`
      fragment LibraryContainer_viewer on User {
        id
        user_line_items(first: 99999) @connection(key: "LibraryContainer_user_line_items") {
          edges {
            node {
              id
              description
              price_cents
              price_currency
              quantity
              title
            }
          }
        }
      }
    `
  }
);



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Library/LibraryContainer.js